import React, { useEffect } from "react";
import './InputField.css';
import { NumericFormat } from 'react-number-format';
import ReactInputMask from "react-input-mask";
import { useRef } from "react";
import { useState } from "react";

const InputField = ({
    setAttribute,
    style,
    type,
    value,
    checked,
    disabled,
    readOnly,
    mask,
    className = 'input-field',
    placeholder,
    onBlur,
    focus,
    decimalScale
}) => {
    const inputRef = useRef(null);

    const focusInput = () => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };

    useEffect(() => {
        if (focus) {
            focusInput();
        }
    }, [focus]);

    const handleSelectChange = (lookupChanged, id) => {
        lookupChanged(id)
    }

    const [isRunning, setIsRunning] = useState(false);
    const [elapsedTime, setElapsedTime] = useState(value || 0);
    const intervalRef = useRef(null);

    useEffect(() => {
        if (isRunning) {
            intervalRef.current = setInterval(() => {
                setElapsedTime(prev => +(prev + 0.01).toFixed(3));
            }, 10);
        } else if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [isRunning]);

    const toggleTimer = () => {
        if (isRunning) {
            setIsRunning(false);
            setAttribute(formatToIndustrialMinutes(elapsedTime)); // Send final value on stop
        } else {
            setIsRunning(true);
        }
    };

    useEffect(() => {
        let interval;
        if (isRunning) {
            interval = setInterval(() => {
                setElapsedTime(prev => prev + 100);
            }, 100);
        } else {
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [isRunning]);

    const formatToIndustrialMinutes = (elapsedTime) => {
        const decimalMinutes = elapsedTime / (60 * 1000);  // ms -> minutos
        return decimalMinutes.toFixed(4).replace('.', ',');
    };

    const clearTimer = (e) => {
        e.stopPropagation();
        setIsRunning(false);
        setElapsedTime(0);
        setAttribute('');
    };

    if (mask === 'timer') {
        return (
            <div
                className="timer-field"
                onClick={toggleTimer}
                style={{
                    position: 'relative',
                    cursor: 'pointer',
                    width: '100%',
                    padding: '10px',
                    userSelect: 'none',
                    backgroundColor: isRunning ? '#e0ffe0' : 'transparent'
                }}
                ref={focus ? inputRef : null}
            >
                <div style={{ fontSize: '18px', fontWeight: 'bold' }}>
                    {formatToIndustrialMinutes(elapsedTime)}
                </div>
                <div style={{ fontSize: '12px' }}>
                    {isRunning ? 'Clique para parar' : 'Clique para iniciar'}
                </div>
                {elapsedTime > 0 && (
                    <div
                        onClick={clearTimer}
                        style={{
                            position: 'absolute',
                            top: '5px',
                            right: '8px',
                            fontWeight: 'bold',
                            fontSize: '14px',
                            cursor: 'pointer',
                            color: '#900',
                            backgroundColor: '#fff',
                            borderRadius: '50%',
                            width: '20px',
                            height: '20px',
                            lineHeight: '20px',
                            textAlign: 'center',
                            boxShadow: '0 0 2px rgba(0,0,0,0.3)'
                        }}
                        title="Limpar"
                    >
                        ×
                    </div>
                )}
            </div>
        );
    }

    const formatToDecimalMinutes = (elapsedTime) => {
        const seconds = elapsedTime / 1000;
        const decimalMinutes = seconds / 60;
        return decimalMinutes.toFixed(4).replace('.', ',');
    };

    if (mask === 'normal-timer') {
        const clearTimer = (e) => {
            e.stopPropagation(); // impedir que clique no "X" inicie/pare o timer
            setIsRunning(false);
            setElapsedTime(0);
            setAttribute('');
        };

        return (
            <div
                className="timer-field"
                onClick={toggleTimer}
                style={{
                    position: 'relative',
                    cursor: 'pointer',
                    width: '100%',
                    padding: '10px',
                    userSelect: 'none',
                    backgroundColor: isRunning ? '#e0ffe0' : 'transparent'
                }}
                ref={focus ? inputRef : null}
            >
                <div style={{ fontSize: '18px', fontWeight: 'bold' }}>
                    {formatToDecimalMinutes(elapsedTime)}
                </div>
                <div style={{ fontSize: '12px' }}>
                    {isRunning ? 'Clique para parar' : 'Clique para iniciar'}
                </div>
                {elapsedTime > 0 && (
                    <div
                        onClick={clearTimer}
                        style={{
                            position: 'absolute',
                            top: '5px',
                            right: '8px',
                            fontWeight: 'bold',
                            fontSize: '14px',
                            cursor: 'pointer',
                            color: '#900',
                            backgroundColor: '#fff',
                            borderRadius: '50%',
                            width: '20px',
                            height: '20px',
                            lineHeight: '20px',
                            textAlign: 'center',
                            boxShadow: '0 0 2px rgba(0,0,0,0.3)'
                        }}
                        title="Limpar"
                    >
                        ×
                    </div>
                )}
            </div>
        );
    }

    if (mask === 'money') {
        return (
            <NumericFormat
                value={value}
                thousandSeparator="."
                decimalSeparator=","
                prefix="R$ "
                decimalScale={2}
                fixedDecimalScale={true}
                onValueChange={(values) => {
                    const { floatValue } = values;
                    if (floatValue || floatValue == 0) {
                        setAttribute(floatValue);
                    } else {
                        setAttribute('');
                    }
                }}
                type="text"
                className="input-field"
                checked={checked}
                disabled={disabled}
                readOnly={readOnly}
                style={style}
                onBlur={onBlur}
                ref={focus ? inputRef : null}
            />
        );
    }

    if (decimalScale) {
        return (
            <NumericFormat
                value={value}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={decimalScale}
                fixedDecimalScale={true}
                onValueChange={(values) => {
                    const { floatValue, formattedValue } = values;
                    if (floatValue === undefined || floatValue === null) {
                        setAttribute('');
                        return;
                    }
                    const decimalPart = formattedValue.split(',')[1] || '';
                    if (decimalPart.length > decimalScale) {
                        setAttribute(0);
                    } else {
                        setAttribute(floatValue);
                    }
                }}
                type="text"
                className="input-field"
                checked={checked}
                disabled={disabled}
                readOnly={readOnly}
                style={style}
                onBlur={onBlur}
                ref={focus ? inputRef : null}
            />
        );
    }

    const handleChange = (e) => {
        handleSelectChange(setAttribute, e.target.value);
    };

    if (mask && mask.toUpperCase() === 'CPF') {
        let className = "input-field";

        if (disabled) {
            className += " disabled";
        }

        return (
            <ReactInputMask
                id="cpf"
                mask="999.999.999-99"
                value={value}
                onChange={!readOnly ? handleChange : null}
                inputRef={focus ? inputRef : null}
            >
                {(inputProps) =>
                    <input
                        {...inputProps}
                        type="text"
                        className={className}
                        style={style}
                    />}
            </ReactInputMask>
        );
    }

    if (mask && mask.toUpperCase() === 'CEP') {
        let className = "input-field";

        if (disabled) {
            className += " disabled";
        }

        return (
            <ReactInputMask
                mask="99999-999"
                value={value}
                onChange={!readOnly ? handleChange : null}
                inputRef={focus ? inputRef : null}
                disabled={disabled}
                readOnly={readOnly}
            >
                {(inputProps) =>
                    <input
                        {...inputProps}
                        type="text"
                        className={className}
                        style={style}
                        placeholder={"00000-000"}
                        onBlur={onBlur}
                    />
                }
            </ReactInputMask>
        );
    }

    if (mask && mask.toUpperCase() === 'CNPJ') {
        let className = "input-field";

        if (disabled) {
            className += " disabled";
        }

        return (
            <ReactInputMask
                id="cpf"
                mask="99.999.999/9999-99"
                value={value}
                onChange={!readOnly ? handleChange : null}
                inputRef={focus ? inputRef : null}
            >
                {(inputProps) =>
                    <input
                        {...inputProps}
                        type="text"
                        className={className}
                        style={style}
                    />}
            </ReactInputMask>
        );
    }

    let mainStyle;
    if (type === 'checkbox') {
        mainStyle = {
            width: '30px'
        }
    }

    return (
        <input
            className={className}
            onChange={(e) => { handleSelectChange(setAttribute, e.target.value) }}
            type={type}
            value={value}
            checked={checked}
            disabled={disabled}
            readOnly={readOnly}
            placeholder={placeholder}
            style={{ ...style, ...mainStyle }}
            onBlur={onBlur}
            ref={focus ? inputRef : null}
        />
    );

};

export default InputField;
